import axios from "axios";
import {encodeDepotCode} from "../helpers.js";

const DEPOT_URL = '/api/depots'
export const DEPOT_TYPES = {
	T: 'Transito',
	R: 'Resi',
	N: 'Errori',
	S: 'Magazzino',
	F: 'Fiera/Negozio',
}

class LocationsService {
	async loadDepotsByType(depotType) {
		const { data: depots } = await axios.get(`${DEPOT_URL}?tipo=${depotType}`);
		return depots;
	}
	
	async loadDepotTypes() {
		const { data } = await axios.get(`${DEPOT_URL}/types`);
		return data.map(({code, quantity}) => ({value: code, label: `${code}: ${DEPOT_TYPES[code]}`, qta: quantity}));
	}
	
	async loadDepot(depotCode) {
		const { data } = await axios.get(`${DEPOT_URL}/${encodeDepotCode(depotCode)}`);
		return data;
	}
	
	async loadProduct(depotCode, ean13) {
		const url = baseProductUrl(depotCode, ean13);
		const {data} = await axios.get(url);
		return data;
	}

	async createIncompleteProduct(ean13) {
		const { data } = await axios.post('/api/incomplete-products', { ean13 });
		return data;
	}
	
	async saveLocatedQuantity(depotCode, ean13, location, qta, stock) {
		const url = baseProductUrl(depotCode, ean13)+'/movement';
		const { data } = await axios.post(url, {location, qta: +qta, asStock: !!stock})
		return data;
	}
}

function baseProductUrl(depotCode, ean13) {
	return `${DEPOT_URL}/${encodeDepotCode(depotCode)}/products/${ean13}`;
}


export default new LocationsService();
